import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import user_img from "../../images/user/user.png";
import useAuth from "../../hooks/useAuth.tsx";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import config from "../../../config.ts";
import ReactCountryFlag from "react-country-flag";

const DropdownUser = () => {
  const { t, i18n } = useTranslation();
  const apiUrl = config.apiUrl;
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const { signOut } = useAuth();

  const trigger = useRef(null);
  const dropdown = useRef(null);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdown.current &&
        !dropdown.current.contains(event.target) &&
        !trigger.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Close on Esc key press
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === "Escape") setDropdownOpen(false);
    };
    document.addEventListener("keydown", handleEscKey);
    return () => document.removeEventListener("keydown", handleEscKey);
  }, []);

  const handleLogout = () => {
    signOut();
    window.location.reload();
  };

  useEffect(() => {
    const fetchData = async () => {
      const accessToken = localStorage.getItem("accessToken");
      const teacherId = localStorage.getItem("teacherId");

      if (!accessToken || !teacherId) {
        console.error("Access token or teacher ID not found in localStorage");
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${apiUrl}/Teachers/me`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const responseData = await response.json();
        setData(responseData.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [apiUrl]);

  if (loading) return <div>{t("Loading")}</div>;
  if (!data) return null;

  const teacher = data;

  return (
    <div className="relative">
      <Link
        ref={trigger}
        onClick={() => setDropdownOpen((prev) => !prev)}
        className="flex items-center gap-4"
        to="#"
      >
        <span className="hidden text-right lg:block">
          <span className="block text-sm font-medium text-black dark:text-white">
            {i18n.language === "gb"
              ? `${teacher.academicPositionShortNameEn} ${teacher.academicRankShortNameEn} ${teacher.firstNameEn} ${teacher.lastNameEn}`
              : `${teacher.academicPositionShortName} ${teacher.academicRankShortName} ${teacher.firstName} ${teacher.lastName}`}
          </span>
        </span>

        <span className="h-12 w-12 rounded-full">
          <img src={user_img} alt="User" />
        </span>

        <svg
          className="hidden fill-current sm:block"
          width="12"
          height="8"
          viewBox="0 0 12 8"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.41 0.91a1.12 1.12 0 011.58 0L6 5.32l4.41-4.41a1.12 1.12 0 111.58 1.58L6.59 7.09a1.12 1.12 0 01-1.58 0L0.41 2.09a1.12 1.12 0 010-1.18z"
          />
        </svg>
      </Link>

      {/* Dropdown */}
      {dropdownOpen && (
        <div
          ref={dropdown}
          className="absolute right-0 mt-2 w-72 bg-white border rounded-md shadow-lg z-10"
        >
          <div className="flex flex-col items-start w-full gap-3.5 px-6 py-4 text-sm font-medium text-black">
            <div>{teacher.userEmail}</div>
            <div className="flex flex-col">
              <span className="text-xs text-black">{t("Department")}</span>
              <span>{teacher.departmentName}</span>
            </div>
            <div className="flex flex-col">
              <span className="text-xs text-black">{t("Faculty")}</span>
              <span>{teacher.facultyName}</span>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="flex items-center w-full gap-3.5 px-6 py-4 text-sm font-medium text-gray-700 hover:text-primary"
          >
            <svg
              className="fill-current"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M15.538 0.62h-3.885a1.65 1.65 0 00-1.65 1.65v2.372c0 .412.343.756.756.756s.756-.344.756-.756V2.23h3.885c.826 0 1.478.653 1.478 1.478v14.747a1.478 1.478 0 01-1.478 1.478h-3.885v-2.372c0-.412-.344-.756-.756-.756s-.756.344-.756.756v2.372a1.65 1.65 0 001.65 1.65h3.885c1.684 0 3.025-1.375 3.025-3.025V3.61c0-1.65-1.341-3.02-3.025-3.02z" />
              <path d="M6.05 11.76h6.153c.412 0 .756-.344.756-.756s-.344-.756-.756-.756H6.084l2.132-2.165a.75.75 0 00-1.1-1.1L3.678 10.48a.75.75 0 000 1.106l3.437 3.506a.75.75 0 001.1-1.1l-2.166-2.166z" />
            </svg>
            {t("logout")}
          </button>
        </div>
      )}
    </div>
  );
};

export default DropdownUser;
